var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLed({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg1",
    width: 101.28,
    height: 14.72,
    viewBox: "0 0 101.27999 14.72",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs1"
  }, /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath439"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path439"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath441"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4380,1533.5)",
    id: "path441"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath443"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "rotate(90,4089,1242.5)",
    id: "path443"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath445"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path445"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath446"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "matrix(-0.20271,-1,-1,0,6319.7912,2875)",
    id: "path446"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath447"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "matrix(0,-1,-1,0,5613,2876)",
    id: "path447"
  })), /*#__PURE__*/React.createElement("clipPath", {
    clipPathUnits: "userSpaceOnUse",
    id: "clipPath449"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 1372,0 H 3352 V 6212 H 1372 V 0",
    transform: "translate(2.0833334e-5,2.0833333e-4)",
    id: "path449"
  })))), /*#__PURE__*/React.createElement("g", {
    id: "layer-oc1",
    transform: "translate(-108.42667,-308.10667)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g453"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path438",
    d: "m 2865,5925 v -607 h -38 v 607 h 38",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath439)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path440",
    d: "M -12.43748,18.74991 C -18.72192,14.58122 -22.5,7.54136 -22.5,0 c 0,-7.54136 3.77808,-14.58122 10.06252,-18.74991",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,112.50667,319.22667)",
    clipPath: "url(#clipPath441)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path442",
    d: "M 12.43748,-18.74991 C 18.72192,-14.58122 22.5,-7.54136 22.5,0 c 0,7.54136 -3.77808,14.58122 -10.06252,18.74991",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0.16,0,0,-0.16,205.62667,319.22667)",
    clipPath: "url(#clipPath443)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "path444",
    d: "M 2846,5925 V 5318",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath445)"
  }), /*#__PURE__*/React.createElement("text", {
    id: "text445",
    xmlSpace: "preserve",
    transform: "matrix(0.16,0,-0.0324336,0.16,140.74667,314.66667)",
    clipPath: "url(#clipPath446)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan445",
    style: {
      fontStyle: "italic",
      fontVariant: "normal",
      fontWeight: "normal",
      fontSize: "48.514px",
      fontFamily: "'GOST Common'",
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 0,
    y: 0
  }, "36W")), /*#__PURE__*/React.createElement("text", {
    id: "text446",
    xmlSpace: "preserve",
    transform: "matrix(0.16,0,0,0.16,160.58667,314.50667)",
    clipPath: "url(#clipPath447)"
  }, /*#__PURE__*/React.createElement("tspan", {
    id: "tspan446",
    style: {
      fontStyle: "italic",
      fontVariant: "normal",
      fontWeight: "normal",
      fontSize: "49.5px",
      fontFamily: "'GOST Common'",
      writingMode: "lr-tb",
      fill: "#000000",
      fillOpacity: 1,
      fillRule: "nonzero",
      stroke: "none"
    },
    x: 0,
    y: 0
  }, "LED")), /*#__PURE__*/React.createElement("path", {
    id: "path448",
    d: "m 2913,5612 v -91 h -39 v 91 h 39",
    style: {
      fill: "none",
      stroke: "#000000",
      strokeWidth: 6,
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeMiterlimit: 10,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    transform: "matrix(0,-0.16,-0.16,0,1058.6667,774.66667)",
    clipPath: "url(#clipPath449)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLed);
export default __webpack_public_path__ + "static/media/led.f0ac7f6640ee7e6a612fb79888deb8b9.svg";
export { ForwardRef as ReactComponent };